import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PetsIcon from '@mui/icons-material/Pets';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Container, { ModalMenu, Villager, MiddleButton, ConfirmButton, InvalidText } from './styles';
import SearchBar from '../SearchBar';
import getVillagers from '../../packages/api/getVillagers';
import Villagers from './Villagers';
import isEmptyObject from '../../utils/isEmptyObject';
import getVillagersName from './getVillagersName';
import Notice from './Notice';
import postListings from '../../packages/api/postListings';

const AnnounceModal = ({ className, isModalOpen, toggleModal, validation, fetchedValidation }) => {
  const [villagers, setVillagers] = useState([]);
  const [oneVillager, setOneVillager] = useState({});
  const [foundImage, setFoundImage] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [filteredVillagers, setFilteredVillagers] = useState([]);
  const [confirming, setConfirming] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const allVillagers = await getVillagers();
      if (Array.isArray(allVillagers)) setVillagers(allVillagers);
    };

    fetchData();
  }, []);

  useEffect(() => {
    getVillagersName(inputValue, villagers, setFilteredVillagers);
  }, [inputValue, villagers]);

  useEffect(() => {
    if (oneVillager.image) {
      setFoundImage(oneVillager.image);
    }
  }, [oneVillager]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isModalOpen]);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleClick = () => {
    const villager = oneVillager._id; // eslint-disable-line
    setConfirming(true)
  };

  const handleConfirm = () => {
    const villager = oneVillager._id; // eslint-disable-line
    const data = { villager };
    toggleModal();
    postListings(data);
    setConfirming(false)
    setOneVillager({})
  };


  const canSeeForm = validation.hasJoinedServer && 
    validation.hasStayedLongEnough && 
    validation.hasValidatedRules && 
    !validation.isBlacklisted;

  return (
    <Container isModalOpen={isModalOpen} className={className}>
      <ModalMenu screenWidth={window.innerWidth}>
        <div className="modal__header">
          <h2 className="modal__title">Offrir un villageois</h2>
          <CloseIcon
            className="closeIcon"
            onClick={toggleModal}
            style={{ color: 'orange' }}
          />
        </div>
        { !validation.hasValidatedRules && 
          <InvalidText>Veuillez accepter le règlement sur Discord dans le salon "rejoindre-le-perchoir".</InvalidText>
        }
        { !validation.hasStayedLongEnough && 
          <InvalidText>Vous devez être membre du perchoir pour au moins 7 jours avant d'offrir un villageois.</InvalidText>
        }
        {
          validation.isBlacklisted &&
          <InvalidText>L'accès à l'application vous a été restreinte, veuillez contacter un·e @Adjoint·e.</InvalidText>
        }
        
        { canSeeForm &&
          <div>
            {
              !(oneVillager._id) &&
              <InvalidText>Veuillez sélectionner un villageois ci-dessous.</InvalidText>
            }
            {
              validation.disallowedVillagers.includes(oneVillager._id) &&
              <InvalidText>Vous avez déjà offert ce villageois dans les derniers 7 jours.</InvalidText>
            }
            { !confirming &&
              <SearchBar
                handleChange={handleChange}
                inputValue={inputValue}
                placeholder="Filibert, Stella..."
              />
            }
            { confirming && <Notice /> }
            <Villagers
              filteredVillagers={filteredVillagers}
              setOneVillager={setOneVillager}
              setInputValue={setInputValue}
            />
            {!isEmptyObject(oneVillager) && (
              <Villager>
                <img src={`/Villageois/${foundImage}`} alt={oneVillager.name.fr} />
                <span>{oneVillager.name.fr}</span>
              </Villager>
            )}
            { oneVillager._id && !validation.disallowedVillagers.includes(oneVillager._id) && !confirming &&
              <div className="buttons__container">
                <button
                  type="button"
                  className="cancel__button"
                  style={{ color: 'hsl(0, 79%, 72%)' }}
                  onClick={toggleModal}
                >
                  Annuler
                </button>
                <MiddleButton onClick={handleClick}>
                  <PetsIcon fontSize="small" className="pet__icon" />
                  Valider
                </MiddleButton>
              </div>
            }
            { confirming &&
              <div className="buttons_confirm__container">
                <ConfirmButton onClick={handleConfirm}>
                  <PetsIcon fontSize="small" className="pet__icon" />
                  Confirmer
                </ConfirmButton>
              </div>
            }
          </div>
        }
      </ModalMenu>
    </Container>
  );
};

AnnounceModal.propTypes = {
  className: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  validation: PropTypes.shape({
    hasJoinedServer: PropTypes.bool.isRequired,
    hasValidatedRules: PropTypes.bool.isRequired,
    hasStayedLongEnough: PropTypes.bool.isRequired,
    isBlacklisted: PropTypes.bool.isRequired,
    disallowedVillagers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  fetchedBoolean: PropTypes.bool.isRequired,
};

export default styled(AnnounceModal)`
  .closeIcon {
    cursor: pointer;
  }
  .buttons__container {
    display: flex;
    justify-content: space-between;
  }
  .buttons_confirm__container {
    display: flex;
    justify-content: space-between;
    flex-direction : row-reverse;
  }
  .cancel__button {
    margin: 0.5rem;
    font-weight: bold;
    border: none;
  }
  .pet__icon {
    transform: rotate(45deg);
  }
`;
